import type { AppThunk } from "../";
import type { PageEnvelope } from "@skv/core";
import { CustomError } from "@skv/core";
import { OpportunitySearchResults } from "@skv/core";

import { OpportunitySearchQueryState } from "../context/OpportunitySearchQuery";
import { opportunitySearchQueryToString } from "./util";

export const addResultsToCache = (
  results: OpportunitySearchResults,
  searchQuery: OpportunitySearchQueryState
): AppThunk<Promise<OpportunitySearchResults>> => async (
  dispatch,
  getState
): Promise<OpportunitySearchResults> => {
  const query = opportunitySearchQueryToString(searchQuery);

  dispatch({
    type: "RESULT:FETCH:END",
    payload: {
      data: results,
      searchQuery: query,
    },
  });

  return results;
};

export const fetchOpportunities = (
  searchQuery?: OpportunitySearchQueryState
): AppThunk<Promise<OpportunitySearchResults>> => async (
  dispatch,
  getState
): Promise<OpportunitySearchResults> => {
  const query = opportunitySearchQueryToString(searchQuery);
  const { opportunityResult } = getState();

  dispatch({
    type: "RESULT:FETCH:START",
  });

  if (opportunityResult.data[query]) {
    dispatch({
      type: "RESULT:FETCH:END:CACHE",
      payload: {
        searchQuery: query,
        data: opportunityResult.data[query],
      },
    });
    return opportunityResult.data[query];
  }

  return fetch(`/api/opportunity/search?${query}`)
    .then<PageEnvelope<{ opportunityResult: OpportunitySearchResults }>>(
      (res) => {
        if (res.ok) {
          return res.json();
        }

        switch (res.status) {
          case 500:
          default:
            throw Error("Unhandled server error");
        }
      }
    )
    .then(({ data, errorCode, errorMessage, success }) => {

      if (success) {
        /* save to cache the same result with the resolved canonicalLocation */
        if (
          data.opportunityResult.canonicalLocation !== null &&
          data.opportunityResult.canonicalLocation !== searchQuery?.where
        ) {
          dispatch(
            addResultsToCache(data.opportunityResult, {
              ...searchQuery,
              where: data.opportunityResult.canonicalLocation,
            })
          );
        }

        dispatch({
          type: "RESULT:FETCH:END",
          payload: {
            searchQuery: query,
            data: data.opportunityResult,
          },
        });

        return data.opportunityResult;
      }

      dispatch({
        type: "RESULT:FETCH:ERROR",
        payload: {
          error: new CustomError(errorMessage, errorCode),
        },
      });
    });
};
